import { ICreateRoute } from 'interfaces/route';
import { cloudFunction } from 'services/parse';
import { DATE_FORMATS, formatDate, metersToMiles, secondsToMinutes } from 'utils';

export const fetchRoutes = async (data: Record<string, any>) => {
  let response = await cloudFunction('fetchRoutes', data);

  response = {
    ...response,
    items: response.items.map(route => ({
      ...route,
      test: '',
      deliveryDateTime: route.deliveryDateTime ? formatDate(route.deliveryDateTime, DATE_FORMATS.MM_DD_YYYY) : '-',
      estimatedRoutingDistance: route.estimatedRoutingDistance ? metersToMiles(route.estimatedRoutingDistance) : '-',
      estimatedRoutingDuration: route.estimatedRoutingDuration ? secondsToMinutes(route.estimatedRoutingDuration) : '-',
      originalEstimatedRoutingDistance: route.estimatedRoutingDistance ,
      originalEstimatedRoutingDuration: route.estimatedRoutingDuration,
    })),
  };
  
  return response;
};

export const fetchAllRoutes = () => {
  return cloudFunction('fetchAllRoutes', {});
};

// eslint-disable-next-line max-len
export const createRoute = (params: ICreateRoute) => {
  return cloudFunction('createRoute', params );
};  

export const fetchRouteDetail = async (id: string) => {
  let response = await cloudFunction('fetchRouteDetail', { id });
  if (response.route?.pickPackList) {
    response = {
      ...response,
      route: {
        ...response.route,
        pickPackList: response.route.pickPackList.toJSON(),
      },
    };
  }
  return response;
};

export const fetchRouteOrders = (params) => {
  return cloudFunction('fetchRouteOrders', params );
};  

export const markRouteAsDelivered = (id: string) => {
  return cloudFunction('markRouteAsDelivered', { id });
};

export const markAllRoutesAsPacked = () =>{
  return cloudFunction('markAllRoutesAsPacked', {});
};

export const markRouteAsPacked = (id: string) =>{
  return cloudFunction('markRouteAsPacked', { id });
};

export const removeRouteFromPickPackList = (routeId: string) => {
  return cloudFunction('removeRouteFromPickPackList', { routeId });
};

export const deleteRoute = (id: string) => {
  return cloudFunction('deleteRoute', { id });
};

export const addRoutesToPickPackList = (pickPackListId: string, routeIds: string[]) => {
  return cloudFunction('addRoutesToPickPackList', { pickPackListId, routeIds });
};